/**
 *
 * ApexOnlineMenuData Service Actions
 *
 */

import { MENU_ITEMS_REQUEST, MENU_ITEMS_SUCCESS, MENU_ITEMS_ERROR, MENU_ITEMS_NOT_ASKED, MENU_ITEMS_LOADING } from './constants';

/**
 * Kicks off the saga that initiates the request.
 */

export function notAsked() {
  return {
    type: MENU_ITEMS_NOT_ASKED
  };
}

export function loading() {
  return {
    type: MENU_ITEMS_LOADING
  };
}

export function request(apiUrl) {
  return {
    type: MENU_ITEMS_REQUEST,
    apiUrl: apiUrl
  };
}

export function success(results) {
  return {
    type: MENU_ITEMS_SUCCESS,
    results: results
  };
}

export function failure(error) {
  return {
    type: MENU_ITEMS_ERROR,
    error: error
  };
}

export default { menuItemsRequest: request, menuItemsSuccess: success, menuItemsError: failure };